import { timestampFromDate } from '@bufbuild/protobuf/wkt';
import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { goBackendApi } from 'hooks/api/httpApi';
import { AnalyticsOrderRequestSchema } from '../../../../../../../../pb/requests/v1/analytics_order_request_pb';
import {
    AnalyticsOrderResponse,
    AnalyticsOrderResponseSchema,
} from '../../../../../../../../pb/responses/v1/analytics_order_response_pb';

export const PROVIDER_ORDER_ANALYTICS_PATH = '/api/v1/orders/analytics/providers';

/** Order counts per provider since `from` */
export const getProviderOrderAnalytics = (from: Date): Promise<AnalyticsOrderResponse> =>
    new ProtobufClient(goBackendApi()).postRequest(
        AnalyticsOrderRequestSchema,
        AnalyticsOrderResponseSchema,
        PROVIDER_ORDER_ANALYTICS_PATH,
        { from: timestampFromDate(from) }
    );
